export default __webpack_public_path__ + "static/media/DB_8.aaa5b7ca.png";